import { styled, css } from '@mui/material/styles';
import { Container } from 'core/common/ui/ui-kit';

export const PageWrapperStyled = styled(Container)`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 32px;
  padding-bottom: 16px;
  ${({ theme }) => theme.breakpoints.up('mobile')} {
    padding-top: 100px;
  }
`;

export const BodyStyled = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: ${theme.palette.background.mainBodyDesktop};
    ${theme.breakpoints.up('mobile')} {
      background-color: ${theme.palette.background.mainBodyMobile};
    }
  `,
);
